import React, { useRef, useState, useEffect } from "react";
import { GridPDFExport } from "@progress/kendo-react-pdf";
import { ExcelExport } from "@progress/kendo-react-excel-export";
import { useTranslation } from "react-i18next";
import Filter from "./Filter";
import {
	getPurchaseStatisticsTotalApi,
	PurchaseStatisticFilter,
} from "api/purchaseStatistic";
//@ts-ignore
import "./style.css";
import { PurchaseStatisticsTotalColumn } from "./utils/GridColumns";
import { useUserStore } from "store";
import { UserRole } from "interface/user";
import GridWithGroupPaging from "ui/grid/GridWithGroupPaging";
import { PurchaseStatisticsTotal } from "interface/purchaseStatistic";
import { PageTypePath } from "utils/pages";
import PurchaseStatisticsTotalMobileList from "./PurchaseStatisticsTotalMobileList";

interface PurchaseStatisticTotalProps {
	pageSize: number;
	filterOptions: PurchaseStatisticFilter;
	setFilterOptions: React.Dispatch<React.SetStateAction<PurchaseStatisticFilter>>;
}

const PurchaseStatisticTotal = ({
	pageSize,
	filterOptions,
	setFilterOptions,
}: PurchaseStatisticTotalProps) => {
	const { t } = useTranslation();
	const [isMobileView, setIsMobileView] = useState<boolean>(() => {
		if (typeof window === "undefined") {
			return false;
		}

		return window.innerWidth < 768;
	});

	const [mobileData, setMobileData] = useState<PurchaseStatisticsTotal[]>([]);
	const [mobileLoading, setMobileLoading] = useState(false);
	const [gridData, setGridData] = useState<any[]>([]);

	const pdfRef = useRef<GridPDFExport>(null);
	const excelRef = useRef<ExcelExport>(null);

	const exportGridAsPDF = () => {
		const fromDate =
			filterOptions.fromDate instanceof Date
				? filterOptions.fromDate.toISOString()
				: "";
		const toDate =
			filterOptions.toDate instanceof Date
				? filterOptions.toDate.toISOString()
				: "";
		localStorage.setItem("fromDate", fromDate);
		localStorage.setItem("toDate", toDate);
		localStorage.setItem("buyerId", filterOptions.buyerId ?? "");
		localStorage.setItem(
			"vesselId",
			filterOptions.vesselLedgerAccountNumber ?? "",
		);

		window.open(`/${PageTypePath.Pdf}/0/4/`, "_blank");
	};

	const exportGridAsExcel = () => {
		if (excelRef.current !== null) {
			excelRef.current.save();
		}
	};

	useEffect(() => {
		const updateMobileView = () => {
			setIsMobileView(window.innerWidth < 768);
		};

		updateMobileView();
		window.addEventListener("resize", updateMobileView);

		return () => {
			window.removeEventListener("resize", updateMobileView);
		};
	}, []);

	useEffect(() => {
		if (!isMobileView) {
			return;
		}

		setMobileLoading(true);

		getPurchaseStatisticsTotalApi(filterOptions as any)
			.then((response) => {
				setMobileData((response || []) as PurchaseStatisticsTotal[]);
			})
			.catch((error) => {
				console.log(error);
				setMobileData([]);
			})
			.finally(() => {
				setMobileLoading(false);
			});
	}, [filterOptions, isMobileView]);
	return (
		<div>
			<div>
				<Filter
					setFilterOptions={setFilterOptions}
					filterOptions={filterOptions}
					exportAsPDF={exportGridAsPDF}
					exportAsExcel={exportGridAsExcel}
					pageSize={pageSize}
					tab="Total"
				/>
			</div>
			<div style={{ marginTop: 30 }}>
				{isMobileView ? (
					<PurchaseStatisticsTotalMobileList
						items={mobileData}
						loading={mobileLoading}
					/>
				) : (
					<GridWithGroupPaging
						unUsedHeight={405}	
						gridColumns={PurchaseStatisticsTotalColumn(gridData)}
						filter={filterOptions}
						exportGridAsPDFRef={pdfRef}
						exportGridAsExcelRef={excelRef}
						apiMethod={getPurchaseStatisticsTotalApi}
						pageable={false}
						showSelectedFilters={false}
						className={"purchaseStatistic-group-grid"}
						groupable={{ footer: "visible", enabled: false }}
						onFilteredDataChange={setGridData}
						itemAboveHeight={20}
						excelProps={{
							filterable: true,
							fileName: `${t("PurchaseStatistic")}_${new Date().toISOString()}.xlsx`,
						}}
						group={
							[
								// {
								// 	field: "buyerName",
								// 	aggregates: [
								// 		{ field: "totalNetWeightKg", aggregate: "sum" },
								// 		{ field: "totalAmount", aggregate: "sum" },
								// 	],
								// },
							]
						}
					/>
				)}
			</div>
		</div>
	);
};

export default PurchaseStatisticTotal;
